import useAuth from 'auth/hook/useAuth';
import useLocalStorage from 'hook/useLocalStorage';
import { createContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

const CartContext = createContext({
  items: [],
  addItems: () => {},
  removeItem: () => {},
  removeAll: () => {},
  invoice: [],
});

export const CartProvider = ({ children }) => {
  const { auth } = useAuth();
  const [storeValue, setStoreValue] = useLocalStorage('cartItems', []);
  const [items, setItems] = useState(storeValue);
  const [selected, setSelected] = useState([]);
  const [invoice, setInvoice] = useState();

  const addItems = (data) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(data);
    }
    data = data.map((x) => {
      return {
        uuid: uuidv4(),
        ...x,
        userId: auth._id,
      };
    });
    let newItems = [...items, ...data];
    setStoreValue(newItems);
    setItems(newItems);
  };

  function handleSelected(data) {
    const value = data.map((d) => d.original);
    setSelected(value);
  }

  function handleRemove() {
    let difference = getDifference(items, selected);
    console.log(difference);
    setItems(difference);
    setStoreValue(difference);
    setSelected([]);
  }

  function handleRemoveAll() {
    setSelected([]);
    setItems([]);
    setStoreValue([]);
  }

  function getDifference(arr1, arr2) {
    const makeDiff = (array1, array2) =>
      array1.filter((object1) => !array2.some((object2) => object1.idCard === object2.idCard));
    return [...makeDiff(arr1, arr2), ...makeDiff(arr2, arr1)];
  }

  const removeItem = (uuid) => {
    let newItems = items.filter((x) => x.uuid !== uuid);
    setStoreValue(newItems);
    setItems(newItems);
  };

  const removeAll = () => {
    setStoreValue([]);
    setItems([]);
  };

  return (
    <CartContext.Provider
      value={{
        items,
        addItems,
        removeItem,
        removeAll,
        invoice,
        setInvoice,
        handleSelected,
        handleRemove,
        handleRemoveAll,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;
